//DONE: check to see what are the parameters for the original bid dispatch action

//DONE: copy over the original bid buttons and use those in place everywhere that isn't with the conditional rendering with the donate buttons
//          *NOTE: looks like this doesn't actually need to happen since it's working as intended for the most part
//          *NOTE: this actually doesn't have to be done since it's just taking the place of the whole element itself

//TODO: double check to make sure that there are no donate variables hiding around
//          *NOTE: this applies for everything OUTSIDE of the donate button classes

//DONE: use the bid value + the giving levels to determine the incremental level of bids
//DONE: Going  have to add anonymity to this manually

//TODO: Add winning animation/div

//TODO: check and make sure that the snackbar is functiong properly
//            *NOTE: It probably just passes it to the ember app which is why we can't see it deployed by itself
import React, { Fragment, useState, useRef, useMemo, useEffect } from 'react'
import {
  Box,
  Fade,
  Typography,
  IconButton,
  TextField,
  useMediaQuery
} from '@material-ui/core'

import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import CloseIcon from '@material-ui/icons/Close'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import { donateAmount } from 'actions/event'
import { useDispatch, useSelector } from 'react-redux'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { openLoginDialog } from 'actions/login-dialog'
import { openSnackBar } from 'actions/snack-bar'
import lottieJson from 'assets/small-lottie.json'
import bigLottie from 'assets/big-lottie.json'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import HelpText from '../HelpText'
import { formatMoney } from 'accounting'
import CheckIcon from '@material-ui/icons/Check'
import Button from '../Button'
import classnames from 'clsx'
import { useFullScreen } from 'react-browser-hooks'
import Gradient from 'components/Gradient'
import { placeBid, getBidAmount } from 'actions/items'
import { ClosedCaptionSharp } from '@material-ui/icons'
import LoaderButton from 'components/LoaderButton'

//originally meant for standarazied donation options
//no longer needed in the bid buttons
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

//looks to be something to deal with the animation on buttons to cause them to shake
const vibrateArr = [
  100,
  50,
  20,
  20,
  20,
  20,
  20,
  300,
  100,
  50,
  20,
  20,
  20,
  20,
  20,
  300,
  100,
  50,
  20,
  20,
  20,
  20,
  20
]

//seem to be the actual donate buttons themselves
class BidButton extends React.Component {
  state = {
    animationTimeout: null
  }
  onStart = e => {
    this.setState({
      animationTimeout: setTimeout(() => {
        //calling the action with the amount
        //going to want props.options.val to be currentBid and currentBid +  1 and currentBid + 2
        this.props.donate(this.props.option.val)
        setTimeout(() => {
          this.setState({ showAnimation: false })
        }, 200)
      }, 200),
      showAnimation: true
    })
  }

  onEnd = e => {
    clearTimeout(this.state.animationTimeout)
    this.setState({ animationTimeout: null, showAnimation: false })
  }

  render() {
    //classes can stay the same
    //options need to be like comment above
    //onClick will be changed through props to be the biding API call
    const { option, classes, onClick } = this.props
    const { showAnimation } = this.state
    return (
      <Button className={classes.donateOption} onAction={onClick}>
        <div
          className={classes.bidGlow}
          style={{
            width: showAnimation ? '100%' : '0%',
            transition: showAnimation
              ? 'width 500ms ease-in-out'
              : 'width 200ms ease-in-out',
            borderRadius: '8px'
          }}
        />
        {/*do we need this function anymore since we arnt using justGiving levels? */}
        ${numberWithCommas(option.val)}
      </Button>
    )
  }
}
/*
Changes made:
  -Renanmed the element from DonateButton -> BidButton
  -documented what is changing in the process of passing in new props/handlers to be used in these new buttons
*/

//Jordan - This serves as form validation for the custom amount HAS to be a number and greater than 0
//No changes need to be made here since I still think we are going to allow custom bids since it can act as the person's Max Bid
const Schema = Yup.object().shape({
  customAmount: Yup.number()
    .required('Custom amount required')
    .min(1, 'Custom amount should be greater than 0')
})

//guessing this is going to be an object that handles how long the thank you animation is played for
let showThanksTimeout = null

/*
Changes made:
  -long story short: ripped out everything and replaced it with donation functionality
  -changed the name of some of the local state variables to make more since in a repurposed element
      *donateSpeedDialOpen -> bidSpeedDialOpen
      *showDonateSuccess -> showBidSuccess
      *selectedDonateAmount -> selectedBidAmount
        thinking about just removing this option outright since we wern't doing that on the original bid buttons
  -added winning/closing to local state
  -changed name for customDonateRef -> customBidRef
  -renamed donateOptions -> bidOptions
      *in case we still want to repurpose it for multiple bid amounts based on the current bid
      *might want to change it to a function so we can update the bid amounts in real time
  -changes the submitDonate function -> submitBid
  -changed variables in the submitBid function to reflect the changes made to the names of local state variables
  -changed handdleButtonClick to reflect local state variable name changes
  -changed donateRef -> bidRed where needed
  -speedDial handlers have been changed to reflect bid name changes
  -submitBid is now just that from the original file with some setState in the switch statement
  -should now be storing the current miniumum bid in local state
      *unless I picked the wrong action from the store
  */

//changed the name so imports won't get messed up
const BidButtons = ({ classes }) => {
  //basic set up from here to ---
  const dispatch = useDispatch()
  const orientation = useSelector(state => state.window.orientation)
  const windowFullscreen = useSelector(state => state.window.fullscreen)
  //NOTE: contains information about items and even gives us the current live item
  const itemsTest = useSelector(state => state.items.liveItem)
  const fullItems = useSelector(state => state.items.items)
  const itemsTestId = useSelector(state => state.items.liveItem.item_id)
  const itemPos = fullItems.indexOf(itemsTest)

  const { fullScreen } = useFullScreen()
  const isLandscape = useMediaQuery(
    '(max-width: 1023px) and (orientation: landscape)'
  )
  const isMobile = useMediaQuery('(max-width: 767px)')
  // ---here allowing for fullscreen and redux access
  // local state to
  const [showThanks, setShowThanks] = useState(false)
  const [bidSpeedDialOpen, setBidSpeedDialOpen] = useState(false)
  const [showBidSuccess, setShowBidSuccess] = useState(false)
  //don't need this either
  const [customAmount, setCustomAmount] = useState('')
  const [selectedBidAmount, setSelectedBidAmount] = useState(0)
  const [showConfirm, setShowConfirm] = useState(false)
  //don't need this current bid anymore since we are just grabbing it from the form itself
  const [currentBid, setCurrentBid] = useState(0.0)
  //this needs to be the user id
  const [currentWinner, setCurrentWinner] = useState(0)
  const [showApprove, setShowApprove] = useState(true)

  const event = useSelector(state => state.event.event)
  //gets the bid approval setting for the event
  const eventBidApproval = useSelector(
    state => state.event.event.require_approval
  )

  const liveSettings = event.live_settings
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const authentication = useSelector(
    state => state.authentication.authenticatedUser
  )
  //variable to hold for approved users
  let userBidSetting = '0'

  useEffect(() => {
    //get the event based on event id / auction code
    try {
      const userBidSettingArray = authenticatedUser.user_events.filter(
        x => x.eid.toString() === event.auction_code.toString()
      )
      userBidSetting = userBidSettingArray[0].approved.toString()
      setShowApprove(
        eventBidApproval.toString() === '0' ||
          (userBidSetting.toString() === '1' &&
            eventBidApproval.toString() === '1')
      )
    } catch (err) {
      userBidSetting = '0'
      console.error(err)
    }
    //set that setting to var
  }, [authenticatedUser, authentication, event, userBidSetting])

  //NOTE: winning needs to be set to the comparison of user_id and high_bid_user
  /*const [winning, setWinning] = useState(
    authenticatedUser.user_id === itemsTest.high_bid_data.high_bid_user_id
  )
  */
  const winning = useMemo(() => {
    return (
      parseInt(authenticatedUser.user_id, 10) ===
      parseInt(itemsTest.high_bid_data.high_bid_user_id, 10)
    )
  }, [authenticatedUser, itemsTest.high_bid_data])
  //NOTE: we can just grab this from the item
  const [closed, setClosed] = useState(false)

  const noBids = useMemo(() => {
    return itemsTest.high_bid !== 0
  }, [itemsTest, itemsTest.high_bid])

  // refs
  //no idea if still needing this since its on bidding buttons now
  const customBidRef = useRef(null)

  //don't need this anymore since this is all donate options
  let bidOptions = []
  if (itemsTest && itemsTest.high_bid) {
    try {
      //grab the bid increment from the item
      bidOptions = [
        {
          val: itemsTest.high_bid + itemsTest.bid_increment,
          label: '$' + (itemsTest.high_bid + itemsTest.bid_increment),
          display: true
        }
      ]
    } catch (err) {
      console.log(err)
    }
  } else {
    bidOptions = [
      {
        val: itemsTest.reserve,
        label: '$' + itemsTest.reserve,
        display: true
      }
    ]
  }

  //login check can pass in the bid function as parameter
  const checkLogin = (cb, ...args) => {
    if (isEmpty(authenticatedUser)) {
      dispatch(openLoginDialog())
        .then(response => {
          cb(...args, response)
        })
        .fail(() => {
          args[1].setSubmitting(false)
        })
    } else {
      cb(...args)
    }
  }

  // this needs to be changed to submitBid
  // also does the submitBid action even care for the loginResponse? Or can we just skip it entirely
  // UPDATE 2021/06/28: It definitely cares about loginResponse, but it's not being passed when needed. `authenticatedUser.user[0].user_id` works as a backup
  const submitBid = (values, actions, loginResponse, anon) => {
    console.log('Submitting bid...')
    return dispatch(
      placeBid({
        item_id: itemsTest.item_id,
        user_id:
          authenticatedUser.user_id ||
          authenticatedUser.user[0].user_id ||
          loginResponse.user_id,
        bid_amt: values.customAmount,
        send_sms: false,
        anon: values.anonFlag
      })
    )
      .then(res => {
        switch (res.msg) {
          case 'item closed':
            openSnackBar({
              message: 'Item is closed for bidding'
            })
            setClosed(true)
            break
          case 'winner':
            openSnackBar({
              message: 'You are now the winning bidder for this item'
            })
            break
          case 'too low':
            openSnackBar({
              message: 'The bid was too low'
            })
            break
          case 'bid max':
            openSnackBar({
              message: `This event has a limited bid per item amount of ${this.props.liveItem.max_bid}`
            })
            break
          case 'bought':
            openSnackBar({
              message: 'You have bought this item'
            })
            break
          default:
            openSnackBar({
              message: 'There may have been an issue placing this bid'
            })
        }
        setShowConfirm(false)
        setShowBidSuccess(true)
        if (navigator.vibrate) {
          navigator.vibrate(vibrateArr)
          setTimeout(() => {
            navigator.vibrate(vibrateArr)
          }, 3000)
          setTimeout(() => {
            navigator.vibrate(vibrateArr)
          }, 6000)
        }
        setTimeout(() => {
          actions.resetForm()
        }, 300)
      })
      .finally(() => {
        if (actions) {
          actions.setSubmitting(false)
        }
      })
  }

  //form validation for custom bid amount
  const Schema = Yup.object().shape({
    customAmount: Yup.number()
      .required('Custom amount required')
      .min(1, 'Custom amount should be greater than 0')
  })

  //guessing the speed dial opens are the predetermined amounts???
  const handleButtonClick = amount => {
    setBidSpeedDialOpen(false)
    if (itemsTest.high_bid === 0 || itemsTest.high_bid < itemsTest.reserve) {
      setSelectedBidAmount(itemsTest.reserve)
    } else if (
      itemsTest.high_bid !== 0 ||
      itemsTest.high_bid > itemsTest.reserve
    ) {
      setSelectedBidAmount(itemsTest.high_bid + itemsTest.bid_increment)
    }
    setTimeout(() => {
      setShowConfirm(true)
    }, 40)
  }

  const handleCloseConfirm = resetForm => {
    setShowConfirm(false)
    setTimeout(() => {
      resetForm()
    }, 300)
  }

  //these just need a name change to BID
  const handleBidSpeedDialOpen = () => {
    setBidSpeedDialOpen(true)
  }

  const handleBidSpeedDialClose = () => {
    setBidSpeedDialOpen(false)
  }
  //End name change

  const handleCloseThanks = () => {
    setShowThanks(false)
    clearTimeout(showThanksTimeout)
    showThanksTimeout = null
  }

  //I believe this is to trigger the multiple "donate buttons" of all giving levels
  const showTapToBid = useMemo(() => {
    return (
      bidOptions.filter(
        x => x && x.hasOwnProperty('display') && x.display.toString() === 'true'
      ).length > 0 || Number(String(event.custom_giving_level))
    )
  }, [bidOptions, event.custom_giving_level])

  //NOTE: we want to rerender this component everytime there is an update to the live item
  useEffect(() => {
    if (itemsTest.high_bid === 0 || itemsTest.high_bid < itemsTest.reserve) {
      setSelectedBidAmount(itemsTest.reserve)
    } else if (itemsTest.high_bid !== 0) {
      setSelectedBidAmount(itemsTest.high_bid + itemsTest.bid_increment)
    }
    if (itemsTest.status === 2) {
      setClosed(true)
    }
    //NOTE: moving the show thanks into the useEffect since we want to only update these values only when the item updates and if the user is winning
    if (winning && itemsTest.status === 2) {
      setShowThanks(true)
      showThanksTimeout = setTimeout(() => {
        setShowThanks(false)
      }, 8000)
    }
  }, [itemsTest, fullItems])

  return (
    <Box
      className={classnames(classes.donateButtons, classes[orientation], {
        [classes.isFullscreen]: fullScreen || windowFullscreen
      })}
    >
      <Fade in={showConfirm} timeout={25}>
        <Box className={classes.blueBox}>
          <Formik
            initialValues={{ customAmount: '' }}
            validationSchema={Schema}
            /*
              most things seem find here other than needing to change the submitDonate function to the submitBid function
              no idea what the args are -- need further documentation, but they are using ... so it doesn't matter how many of then there are
            */
            onSubmit={(...args) => checkLogin(submitBid, ...args)}
          >
            {props => (
              <Form className={classes.form}>
                <IconButton
                  size="small"
                  className={classes.closeConfirmButton}
                  /*
                    don't think I need to handle the props.resetForm?
                    I believe whatever prop that is handling it is still there
                  */
                  onClick={() => handleCloseConfirm(props.resetForm)}
                >
                  <CloseIcon />
                </IconButton>
                <Fragment>
                  {/*
                      Once again just need to change the text to 
                      "Youn are bidding"
                    */}
                  <Typography className={classes.confirmText}>
                    You are bidding{' '}
                    {/*
                      Unsure if we have to use the formatMoney function since I don't think we are using it in the bidding buttons
                      Should probably still use it since thats hows the original donate buttons we designed
                      */}
                    {formatMoney(selectedBidAmount, '$', 0)}
                  </Typography>
                  <LoaderButton
                    type="button"
                    onClick={() => {
                      props.setFieldValue('customAmount', selectedBidAmount)
                      props.setFieldValue('anonFlag', 0)
                      setTimeout(() => {
                        props.handleSubmit()
                      }, 40)
                    }}
                    variant="contained"
                    classes={{ button: classes.confirmButton }}
                    working={props.isSubmitting && props.values.anonFlag === 0}
                    disabled={props.isSubmitting}
                  >
                    Confirm
                  </LoaderButton>
                  <LoaderButton
                    type="button"
                    onClick={() => {
                      props.setFieldValue('customAmount', selectedBidAmount)
                      props.setFieldValue('anonFlag', 1)
                      setTimeout(() => {
                        props.handleSubmit()
                      }, 40)
                    }}
                    variant="contained"
                    classes={{ button: classes.confirmButton }}
                    working={props.isSubmitting && props.values.anonFlag === 1}
                    disabled={props.isSubmitting}
                  >
                    Confirm Anonymously
                  </LoaderButton>
                </Fragment>
              </Form>
            )}
          </Formik>
        </Box>
      </Fade>
      <Fade
        in={
          showConfirm === false && showThanks === false && !winning && !closed
        }
        timeout={25}
      >
        <div>
          {((!isLandscape && !liveSettings.compact_buttons) || isMobile) &&
            showApprove && (
              <Box className={classes.donateButtonsBox}>
                {/*
              need to change helper name
              should look more in depth to make sure that name changes and code base changes don't affect functionality
              need to change text to Tap to bid
              Are we going to show how much they are going to bid out the gate or let later buttons handle that
              */}
                {showTapToBid && !noBids && <HelpText>Starting bid</HelpText>}
                {showTapToBid && noBids && <HelpText>Tap to bid</HelpText>}

                <Box
                  display="flex"
                  justifyContent="center"
                  className={classes.buttons}
                >
                  <Box className={classes.amountButtons}>
                    {bidOptions
                      .filter(
                        x =>
                          x &&
                          x.hasOwnProperty('display') &&
                          x.display.toString() === 'true'
                      )
                      .map((option, i) => {
                        /*
                           Don't know if we care what the DonateButton elements itself is called or if we want to change that
                          I think we are though
                          need to spereate out these new bid buttons into their own seperate element to not affect other areas of the project
                      */

                        return (
                          <BidButton
                            key={i}
                            option={option}
                            classes={classes}
                            onClick={() => handleButtonClick(option.val)}
                            // donate={() => submitDonate({ customAmount: option.val })}
                          />
                        )
                      })}
                  </Box>
                  {/* amountButtons */}
                </Box>
                {/* buttons */}
              </Box>
            )}
          {/*NOTE: requires all of the following AND for the require approval from the event and user */}
          {(isLandscape || liveSettings.compact_buttons) &&
            !isMobile &&
            !winning &&
            !closed &&
            showApprove && (
              <Box className={classes.donateButtonsBox}>
                <SpeedDial
                  ariaLabel="Bid"
                  className={classes.speedDial}
                  FabProps={{
                    color: 'secondary'
                  }}
                  icon={<Typography>Bid</Typography>}
                  onClose={handleBidSpeedDialClose}
                  onOpen={handleBidSpeedDialOpen}
                  open={bidSpeedDialOpen}
                  direction="up"
                >
                  {bidOptions
                    .filter(
                      x =>
                        x &&
                        x.hasOwnProperty('display') &&
                        x.display.toString() === 'true'
                    )
                    .map((option, i) => {
                      return (
                        <SpeedDialAction
                          TooltipClasses={{ popper: classes.tooltip }}
                          key={i}
                          icon={
                            <Typography>
                              ${numberWithCommas(option.val)}
                            </Typography>
                          }
                          onClick={() => handleButtonClick(option.val)}
                        />
                      )
                    })}
                  {/* amountButtons */}
                </SpeedDial>
              </Box>
            )}
          {/* fade inner Box */}
        </div>
      </Fade>
      {!liveSettings.compact_buttons && <Gradient />}
      {winning && !closed && (
        <Box className={classes.helpTextContainer}>
          <HelpText className={classes.winning}>WINNING!</HelpText>
        </Box>
      )}
      {!winning && closed && (
        <Box className={classes.helpTextContainer}>
          <HelpText className={classes.winning}>ITEM CLOSED</HelpText>
        </Box>
      )}
      {winning && closed && (
        <Box className={classes.helpTextContainer}>
          <HelpText className={classes.winning}>YOU WON!</HelpText>
        </Box>
      )}
      {/*This serves to show the gradiant associated with whatever state the bid war is in */}

      <Gradient
        classNames={{
          [classes.gradientBlue]: !winning,
          [classes.gradientGreen]: winning && !closed,
          [classes.gradientGrey]: closed && !winning
        }}
      />
    </Box>
  )
}
export default withStyles(styles, { withTheme: true })(BidButtons)



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/BidButton/index.jsx